import React, { useState, useCallback } from 'react';

import { OETextInput } from '../../atoms/oe-text-input/oe-text-input';
import FormFooter from '../../molecules/form-footer/form-footer';
import TextInputWithLink from '../../molecules/text-input-with-link/text-input-with-link';
import { mt } from '../../style-utils';

export interface CognitoLoginFormLabels {
  emailLabel: string;
  passwordLabel: string;
  passwordLink?: string;
  buttonSubmit: string;
}
export interface CognitoLoginFormProps {
  onRecoverPassword: () => void;
  onSubmit: (email: string, password: string) => void;
  labels: CognitoLoginFormLabels;
  isLoading?: boolean;
  error?: string;
}

export const CognitoLoginForm: React.FC<CognitoLoginFormProps> = ({
  onRecoverPassword,
  labels,
  isLoading,
  error,
  onSubmit,
}) => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  const handleFieldChange = (value: string, name?: string) => {
    if (name) {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = useCallback(() => {
    onSubmit(formData.email, formData.password);
  }, [onSubmit, formData]);

  const { email, password } = formData;

  return (
    <>
      <OETextInput
        label={labels.emailLabel}
        name="email"
        autoComplete="email"
        textContentType="emailAddress"
        onChangeText={handleFieldChange}
        value={email}
        style={mt(32)}
      />
      <TextInputWithLink
        linkText={labels.passwordLink}
        label={labels.passwordLabel}
        name="password"
        autoComplete="password"
        textContentType="password"
        onLinkPress={onRecoverPassword}
        onChangeText={handleFieldChange}
        value={password}
        containerStyle={mt(32)}
        secure
      />
      <FormFooter
        buttonSubmit={{
          onPress: handleSubmit,
          loading: isLoading,
          disabled: !email || !password,
          label: labels.buttonSubmit,
        }}
        error={error}
      />
    </>
  );
};

export default CognitoLoginForm;
